/**
 * Created by mnaughton on 12/3/2015.
 */

import BaseRouter from "core/base/Router";
import UrlBuilder from "@HBKEngineering/url-builder";
import logger from "app/Logger";
import urlService from "app/UrlService";
import messenger from "app/Messenger";
import app from "app/App";
export default BaseRouter.extend({
  /**
   * Gets the root URL of this router.
   * @return {String} The normalized, relative root URL
   */
  getRootUrl: function () {
    return urlService.url(this.root);
  },

  /**
   * Gets the root URL of api endpoints.
   * @return {String} The relative root api URL.
   * @protected
   */
  getApiRoot: function () {
    return urlService.apiurl("/");
  },

  /**
   * Gets the URL associated with the given route.
   * @param {string} route The route.
   * @return {String} The normalized route.
   * @protected
   */
  getRouteUrl: function (route) {
    var urlBuilder = new UrlBuilder("");

    return urlBuilder.url(route);
  },

  navigate: function (href) {
    logger.navigation(href);
    return BaseRouter.prototype.navigate.apply(this, arguments);
  },

  /**
   * A function called when an error occurs during the load of a router.
   * @param err The error.
   */
  onLoadError: function (err) {
    messenger.error(err);
  },

  beforeExecute: function () {
    app.enableScroll();
    app.clearActions();
  },

  getApp: function () {
    return app;
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/RouterBase.js
// module id = 64
// module chunks = 1